import { Box } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { TanstackButtonLink } from '@/components/menu-button'
import { largeTabletAndDown } from '@/styles/media'

export const HeaderContainer = styled(Box).attrs({
  $px: 8,
  $display: 'flex',
  $direction: 'column',
  $align: 'flex-start',
})`
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  margin: 0 -${({ theme }) => theme.space[8]};
  background-color: ${({ theme }) => theme.colors.surface};
  ${largeTabletAndDown(css`
    border: none;
    padding: 0;
    margin: ${({ theme }) => theme.space[6]} 0;
    gap: ${({ theme }) => theme.space[6]};
  `)}
`

export const TitleContainer = styled(Box).attrs({
  $py: 8,
  $display: 'flex',
  $align: 'initial',
  $gap: 1,
  $direction: 'column',
  $fullWidth: true,
})`
  ${largeTabletAndDown(css`
    padding: 0;
  `)}
`

export const MainContentContainer = styled(Box).attrs({
  $pt: 8,
})`
  width: calc(100% - var(--sidebar-width) - ${({ theme }) => theme.space[6]});
  &[data-has-sidebar='false'] {
    width: 100%;
  }
  ${largeTabletAndDown(css`
    width: 100%;
    padding: 0;
    margin: 0 auto;
    max-width: 600px;
  `)}
`

export const SubNavLinkContainer = styled.ul`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[5]};
  list-style: none;
  padding: 0;
  margin: 0;
`

export const SubNavLink = styled(TanstackButtonLink).attrs({
  variant: 'flat',
  color: 'tertiary',
})`
  padding-left: 0;
  padding-right: 0;
  border-radius: 0;
  padding-bottom: ${({ theme }) => theme.space[3]};
  &[data-status='active'] {
    box-shadow: inset 0 -4px 0 ${({ theme }) => theme.colors.selection};
  }
`

export const SubNavMenuDesktopContainer = styled(Box)`
  margin-bottom: -1px;
  ${largeTabletAndDown(css`
    display: none;
  `)}
`
